<div class="page-not-found">
  <div class="page-not-found__title">404</div>

  <div class="page-not-found__subtitle xl-title-text">Oops! Something went wrong.</div>

  <gg-button styleType="raised-button" (clickEvent)="goToHomePage()">Go to Home Page</gg-button>
</div>
